<template>
    <nav v-if="pages.length" class="flex mt-2" aria-label="Breadcrumb">
        <ol role="list" class="flex items-center space-x-4">
            <li>
                <div>
                    <Link href="/" class="text-gray-400 hover:text-gray-500">
                        <HomeIcon class="h-5 w-5 flex-shrink-0" aria-hidden="true" />
                    </Link>
                </div>
            </li>
            <li v-for="page in pages" :key="page.name">
                <div class="flex items-center">
                    <ChevronRightIcon
                        class="h-5 w-5 flex-shrink-0 text-gray-400"
                        aria-hidden="true"
                    />
                    <Link
                        v-if="page.href && page.href !== '#'"
                        :href="page.href"
                        class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                        :aria-current="page.current ? 'page' : undefined"
                        >{{ page.name }}</Link
                    >
                    <span
                        v-else
                        class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                        :aria-current="page.current ? 'page' : undefined"
                        >{{ page.name }}</span
                    >
                </div>
            </li>
        </ol>
    </nav>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import { ChevronRightIcon, HomeIcon } from "@heroicons/vue/outline";

export default {
    name: "Breadcrumb",
    components: {
        Link,
        HomeIcon,
        ChevronRightIcon,
    },
    props: {
        pages: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
};
</script>

<style scoped></style>
